import type { ReactNode } from 'react'
import s from './EmptyState.module.css'

/**
 * What a card or screen shows when there's nothing to show. Say why, and what would fill it.
 * `first-run`: nothing exists yet (offer the action that fills it). `no-match`: filters hide everything (offer to clear).
 */
export function EmptyState(props: { title: string; body?: string; action?: ReactNode; kind?: 'first-run' | 'no-match' }) {
  return (
    <div className={s.empty} data-kind={props.kind ?? 'first-run'}>
      <h3 className={s.title}>{props.title}</h3>
      {props.body && <p className={s.body}>{props.body}</p>}
      {props.action && <div className={s.actions}>{props.action}</div>}
    </div>
  )
}
